import React from 'react';
import { CatalogSource } from '@1po/1po-bff-fe-spec/generated/common/vehicle/CatalogSource';
import { DetailTable } from 'pages/CatalogPage/common/TechnicalCriteria/TechnicalCriteriaPdfTable.styled';
import {
  useGetTechnicalPdfDataDh,
  useGetTechnicalPdfDataIam,
} from 'pages/CatalogPage/common/TechnicalCriteria/useGetTechnicalPdfData';
import { Text } from 'UI';

const TechnicalCriteriaPdfTable = ({ catalogSource }: { catalogSource: CatalogSource }) => {
  const technicalDataIam = useGetTechnicalPdfDataIam();
  const technicalDataDh = useGetTechnicalPdfDataDh();
  const isIam = catalogSource === 'IAM';
  const tableData = isIam ? technicalDataIam : technicalDataDh;
  return (
    <DetailTable>
      <table>
        <tbody>
          {tableData.map(({ title, value }) => {
            return (
              <tr key={title}>
                <td>
                  <Text type="base" bold>
                    {title}
                  </Text>
                </td>
                <td>{value}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </DetailTable>
  );
};

export default TechnicalCriteriaPdfTable;
